/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { useLabels } from '@/hooks/useLabels';
import styles from './styles.module.scss';
import { Text, View } from '@az/starc-ui';
import Image from '@/components/NextImage';
import { useReviewSummary } from '@/features/customReviews/api/getReviewSummary';
import { useProductDetails } from '@/features/product/api/getProductDetails';
import { Content } from '../Review/Content/Content';

const labelMap = {
  reviewSummary: 'label_reviews_reviewSummary',
  aiLegend: 'label_reviews_AILegend',
};

export const ReviewSummary = () => {
  const labels = useLabels(labelMap);
  const { data: productDetails } = useProductDetails();

  const skuNumber = productDetails?.product?.itemId ?? '';

  const { data } = useReviewSummary({ skuNumber, enabled: !!skuNumber });

  if (!data?.reviewSummaryText) return null;

  return (
    <View maxWidth={'830px'}>
      <Text variant="main-body" weight="bold" className={styles.heading}>
        {labels.reviewSummary}
      </Text>
      <View padding={1.5} />
      <Content truncate={false} text={data?.reviewSummaryText ?? ''} />
      <View padding={1} />
      <View direction={'row'} align={'center'} className={styles.aiLegend}>
        <Image src={'/images/reviews/ai.svg'} alt="" width={18} height={18} />
        <Text variant="subtitle-bold">{labels.aiLegend}</Text>
      </View>
    </View>
  );
};
